import { call, put, takeLatest } from "redux-saga/effects";
import {
    reportsStart, reportsSuccess, reportsFailure, bdmReportsStart, bdmReportsSuccess, bdmReportsFailure, recruiterReportsSuccess,
    recruiterReportsStart,
    recruiterEmailDelivaryReportSuccess,
    recruiterEmailDelivaryReportStart,
    recruiterEmailDelivaryReportNewStart,
    recruiterEmailDelivaryReportNewFailure,
    recruiterEmailDelivaryReportNewSuccess,
    emailsSkippedStart,
    emailsSkippedSuccess,
    emailsSkippedFailure,
    emailsQueuedSuccess,
    emailsQueuedFailure,
    emailsQueuedStart,
    emailsSentSuccess,
    emailsSentFailure,
    emailsSentStart,
    emailsFailedSuccess,
    emailsFailedFailure,
    emailOpenedSuccess,
    emailOpenedFailure,
    emailClickedSuccess,
    emailClickedFailure,
    emailsFailedStart,
    emailOpenedStart,
    emailClickedStart,
    emailTemporaryFailedSuccess,
    emailTemporaryFailedFailure,
    emailPermanentFailedFailure,
    emailPermanentFailedSuccess,
    emailSpamComplainedFailure,
    emailSpamComplainedSuccess,
    emailUnsubScribeSuccess,
    emailUnsubScribeFailure,
    emailTemporaryFailedStart,
    emailPermanentFailedStart,
    emailSpamComplainedStart,
    emailUnsubScribeStart
} from "./reportsSlice";
import { fetchRaSummaryReport, fetchBdmSummaryReport, fetchRecruiterSummaryReport, fetchRecruiterEmailDelivaryReport, fetchReports, addFavouriteReportApi, fetchFavouriteReportsApi, deleteFavouriteReportApi, fetchRecruiterEmailDelivaryReportNew, fetchEmailReportDataApi } from "./reportsApi";
import { bdmReportsListStart, bdmReportsListSuccess, raReportsListFailure, raReportsListStart, raReportsListSuccess, recruiterEmailDelivaryReportsListStart, recruiterEmailDelivaryReportsListSuccess, recruiterReportsListStart, recruiterReportsListSuccess } from "./reportListSlice";
import { addBdmFavouriteReportStart, addRaFavouriteReportStart, addRecruiterEmailDelivaryFavouriteReportStart, addRecruiterFavouriteReportStart, bdmFavouriteReportsStart, bdmFavouriteReportsSuccess, deleteBdmFavouriteReportStart, deleteBdmFavouriteReportSuccess, deleteRaFavouriteReportStart, deleteRaFavouriteReportSuccess, deleteRecruiterEmailDelivaryFavouriteReportStart, deleteRecruiterEmailDelivaryFavouriteReportSuccess, deleteRecruiterFavouriteReportStart, deleteRecruiterFavouriteReportSuccess, raFavouriteReportsFailure, raFavouriteReportsStart, raFavouriteReportsSuccess, recruiterEmailDelivaryFavouriteReportsStart, recruiterEmailDelivaryFavouriteReportsSuccess, recruiterFavouriteReportsStart, recruiterFavouriteReportsSuccess } from "./favouriteReportsSlice";

function* fetchRaReportsWorker(action) {
    try {
        const response = yield call(fetchRaSummaryReport, action.payload);
        const data = response?.data?.data || [];
        yield put(reportsSuccess({ data: data }));
    } catch (error) {
        yield put(reportsFailure({ error: error.message }));
    }
}

function* fetchBdmReportsWorker(action) {
    try {
        const response = yield call(fetchBdmSummaryReport, action.payload);
        const data = response?.data?.data || [];
        yield put(bdmReportsSuccess({ data: data }));
    } catch (error) {
        yield put(bdmReportsFailure({ error: error.message }));
    }
}

function* fetchRecruiterReportsWorker(action) {
    try {
        const response = yield call(fetchRecruiterSummaryReport, action.payload);
        const data = response?.data?.data || [];
        yield put(recruiterReportsSuccess({ data: data }));
    } catch (error) {
        yield put(reportsFailure({ error: error.message }));
    }
}

function* fetchRecruiterEmailDelivaryReportWorker(action) {
    try {
        const response = yield call(fetchRecruiterEmailDelivaryReport, action.payload);
        const data = response?.data?.data || [];
        yield put(recruiterEmailDelivaryReportSuccess({ data: data }));
    } catch (error) {
        yield put(reportsFailure({ error: error.message }));
    }
}

function* fetchReportsList(action) {
    try {
        let successAction;
        switch (action.payload.reportType) {
            case "RA":
                successAction = raReportsListSuccess;
                break;
            case "BDM":
                successAction = bdmReportsListSuccess;
                break;
            case "RECRUITER":
                successAction = recruiterReportsListSuccess;
                break;
            case "EMAIL":
                successAction = recruiterEmailDelivaryReportsListSuccess;
                break;
            default:
                successAction = raReportsListSuccess;
        }
        const response = yield call(fetchReports, action.payload);
        const data = response?.data?.data || [];
        yield put(successAction({ data: data }));
    } catch (error) {
        yield put(raReportsListFailure({ error: error.message }));
    }
}

function* fetchFavouriteReports(action) {
    try {
        let successAction;
        switch (action.payload.reportType) {
            case "RA":
                successAction = raFavouriteReportsSuccess;
                break;
            case "BDM":
                successAction = bdmFavouriteReportsSuccess;
                break;
            case "RECRUITER":
                successAction = recruiterFavouriteReportsSuccess;
                break;
            case "EMAIL":
                successAction = recruiterEmailDelivaryFavouriteReportsSuccess;
                break;
            default:
                successAction = raFavouriteReportsSuccess;
        }
        const response = yield call(fetchFavouriteReportsApi, action.payload);
        const data = response?.data?.data || [];
        yield put(successAction({ data: data }));
    } catch (error) {
        yield put(raFavouriteReportsFailure({ error: error.message }));
    }
}


function* addFavouriteReport(action) {
    try {
        let favFunction;
        switch (action.payload.reportCategory) {
            case 1:
                favFunction = raFavouriteReportsStart;
                break;
            case 2:
                favFunction = bdmFavouriteReportsStart;
                break;
            case 3:
                favFunction = recruiterFavouriteReportsStart;
                break;
            case 4:
                favFunction = recruiterEmailDelivaryFavouriteReportsStart;
                break;
            default:
                favFunction = raFavouriteReportsStart;
        }

        const response = yield call(addFavouriteReportApi, action.payload.actualPayload);
        const adddata = response?.data;
        yield put(favFunction(action.payload.fetchPayload));
    }
    catch (error) {
        yield put(raFavouriteReportsFailure({ error: error.message }));
    }
}

function* deleteFavouriteReport(action) {
    try {
        let favFunction;
        switch (action.payload.reportCategory) {
            case 1:
                favFunction = raFavouriteReportsStart;
                break;
            case 2:
                favFunction = bdmFavouriteReportsStart;
                break;
            case 3:
                favFunction = recruiterFavouriteReportsStart;
                break;
            case 4:
                favFunction = recruiterEmailDelivaryFavouriteReportsStart;
                break;
            default:
                favFunction = raFavouriteReportsStart;
        }

        const response = yield call(deleteFavouriteReportApi, action.payload.actualPayload);
        const data = response?.data;
        yield put(favFunction(action.payload.fetchPayload));
    }
    catch (error) {
        yield put(raFavouriteReportsFailure({ error: error.message }));
    }
}

function* fetchRecruiterEmailDelivaryReportNewWorker(action) {
    try {
        const response = yield call(fetchRecruiterEmailDelivaryReportNew, action.payload);
        const data = response?.data?.data || [];
        yield put(recruiterEmailDelivaryReportNewSuccess({ data: data }));
    } catch (error) {
        yield put(recruiterEmailDelivaryReportNewFailure({ error: error.message }));
    }
}

function* fetchEmailsSkippedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailsSkippedSuccess({ data }));
    } catch (error) {
        yield put(emailsSkippedFailure({ error: error.message }));
    }
}

function* fetchEmailsQueuedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailsQueuedSuccess({ data }));
    } catch (error) {
        yield put(emailsQueuedFailure({ error: error.message }));
    }
}

function* fetchEmailsSentWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailsSentSuccess({ data }));
    } catch (error) {
        yield put(emailsSentFailure({ error: error.message }));
    }
}

function* fetchEmailsFailedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailsFailedSuccess({ data }));
    } catch (error) {
        yield put(emailsFailedFailure({ error: error.message }));
    }
}

function* fetchEmailsOpenedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailOpenedSuccess({ data }));
    } catch (error) {
        yield put(emailOpenedFailure({ error: error.message }));
    }
}

function* fetchEmailsclickedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailClickedSuccess({ data }));
    } catch (error) {
        yield put(emailClickedFailure({ error: error.message }));
    }
}

function* fetchEmailstemporaryFailedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailTemporaryFailedSuccess({ data }));
    } catch (error) {
        yield put(emailTemporaryFailedFailure({ error: error.message }));
    }
}

function* fetchEmailspermanentFailedWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailPermanentFailedSuccess({ data }));
    } catch (error) {
        yield put(emailPermanentFailedFailure({ error: error.message }));
    }
}

function* fetchEmailsspamWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailSpamComplainedSuccess({ data }));
    } catch (error) {
        yield put(emailSpamComplainedFailure({ error: error.message }));
    }
}

function* fetchEmailsUnsubscribeWorker(action) {
    try {
        const response = yield call(fetchEmailReportDataApi, action.payload);   
        const data = response?.data?.data;
        yield put(emailUnsubScribeSuccess({ data }));
    } catch (error) {
        yield put(emailUnsubScribeFailure({ error: error.message }));
    }
}

export function* watchReportsSaga() {
    yield takeLatest(reportsStart.type, fetchRaReportsWorker);
    yield takeLatest(bdmReportsStart.type, fetchBdmReportsWorker);
    yield takeLatest(recruiterReportsStart.type, fetchRecruiterReportsWorker);
    yield takeLatest(recruiterEmailDelivaryReportStart.type, fetchRecruiterEmailDelivaryReportWorker);
    yield takeLatest(recruiterEmailDelivaryReportNewStart.type, fetchRecruiterEmailDelivaryReportNewWorker);
    yield takeLatest(raReportsListStart.type, fetchReportsList);
    yield takeLatest(bdmReportsListStart.type, fetchReportsList);
    yield takeLatest(recruiterReportsListStart.type, fetchReportsList);
    yield takeLatest(recruiterEmailDelivaryReportsListStart.type, fetchReportsList);
    yield takeLatest(raFavouriteReportsStart.type, fetchFavouriteReports);
    yield takeLatest(bdmFavouriteReportsStart.type, fetchFavouriteReports);
    yield takeLatest(recruiterFavouriteReportsStart.type, fetchFavouriteReports);
    yield takeLatest(recruiterEmailDelivaryFavouriteReportsStart.type, fetchFavouriteReports);
    yield takeLatest(addRaFavouriteReportStart.type, addFavouriteReport);
    yield takeLatest(addBdmFavouriteReportStart.type, addFavouriteReport);
    yield takeLatest(addRecruiterFavouriteReportStart.type, addFavouriteReport);
    yield takeLatest(addRecruiterEmailDelivaryFavouriteReportStart.type, addFavouriteReport);
    yield takeLatest(deleteRaFavouriteReportStart.type, deleteFavouriteReport);
    yield takeLatest(deleteBdmFavouriteReportStart.type, deleteFavouriteReport);
    yield takeLatest(deleteRecruiterFavouriteReportStart.type, deleteFavouriteReport);
    yield takeLatest(deleteRecruiterEmailDelivaryFavouriteReportStart.type, deleteFavouriteReport);
    yield takeLatest(emailsSkippedStart.type, fetchEmailsSkippedWorker);
    yield takeLatest(emailsQueuedStart.type, fetchEmailsQueuedWorker);
    yield takeLatest(emailsSentStart.type, fetchEmailsSentWorker);
    yield takeLatest(emailsFailedStart.type, fetchEmailsFailedWorker);
    yield takeLatest(emailOpenedStart.type, fetchEmailsOpenedWorker);
    yield takeLatest(emailClickedStart.type, fetchEmailsclickedWorker);
    yield takeLatest(emailTemporaryFailedStart.type, fetchEmailstemporaryFailedWorker);
    yield takeLatest(emailPermanentFailedStart.type, fetchEmailspermanentFailedWorker);
    yield takeLatest(emailSpamComplainedStart.type, fetchEmailsspamWorker);
    yield takeLatest(emailUnsubScribeStart.type, fetchEmailsUnsubscribeWorker);
}